import SignUpAddress from './signUpAddress/signUpAddress';
import SignUpPersonalInfo from './signUpPersonalInfo/SignUpPersonalInfo';
import SignUpCode from './signUpCode/SignUpCode';
import SignUpPassword from './signUpPassword/SignUpPassword';
import { SignUpProps } from './SignUpInterface';

export const AllSignUpSteps = ({
  changeStep,
  setUser,
  user,
  loading,
  setLoading,
  showWarning,
  setShowWarning,
  warningMessage,
  setWarningMessage,
  country,
  setCountry,
  createdUser,
  setCreatedUser,
}: SignUpProps) => {
  return [
    {
      page: (
        <SignUpPersonalInfo
          changeStep={(nextStep: boolean) => changeStep(nextStep)}
          setUser={setUser}
          user={user}
          loading={loading}
          setLoading={setLoading}
          showWarning={showWarning}
          setShowWarning={setShowWarning}
          warningMessage={warningMessage}
          setWarningMessage={setWarningMessage}
          country={country}
          setCountry={setCountry}
        />
      ),
      title: 'create_account_step_1_subtitle',
    },
    {
      page: (
        <SignUpAddress
          changeStep={(nextStep: boolean) => changeStep(nextStep)}
          setUser={setUser}
          user={user}
          loading={loading}
          setLoading={setLoading}
          showWarning={showWarning}
          setShowWarning={setShowWarning}
          warningMessage={warningMessage}
          setWarningMessage={setWarningMessage}
        />
      ),
      title: 'signInAddress:create_account_step_2_subtitle',
    },
    {
      page: (
        <SignUpPassword
          changeStep={(nextStep: boolean) => changeStep(nextStep)}
          setUser={setUser}
          user={user}
          loading={loading}
          setLoading={setLoading}
          showWarning={showWarning}
          setShowWarning={setShowWarning}
          warningMessage={warningMessage}
          setWarningMessage={setWarningMessage}
          createdUser={createdUser}
          setCreatedUser={setCreatedUser}
        />
      ),
      title: 'signInPassword:create_account_step_3_subtitle',
    },
    {
      page: (
        <SignUpCode
          changeStep={(nextStep: boolean) => changeStep(nextStep)}
          setUser={setUser}
          user={user}
          loading={loading}
          setLoading={setLoading}
          showWarning={showWarning}
          setShowWarning={setShowWarning}
          warningMessage={warningMessage}
          setWarningMessage={setWarningMessage}
        />
      ),
      title: 'signInCode:create_account_step_4_subtitle',
    },
  ];
};
